<template>
  <div class="loadingBox">
    <span class="peopleing"></span>
    <h3>{{way=='1' ? "正在努力加载商品...." : '正在加载中....'}}</h3>
  </div>
</template>


<script>
  export default {
    props:["way"],
    data() {
      return {
      }
    }
  }
</script>

<style scoped lang="less">
   @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loadingBox {
    text-align:center;
    .peopleing {
      display: inline-block;
      width: 106px;
      height: 56px;
      background-image: linear-gradient(#ff6700 50px, transparent 0), linear-gradient(#ff6700 50px, transparent 0),
      linear-gradient(#ff6700 50px, transparent 0), linear-gradient(#ff6700 50px, transparent 0), radial-gradient(circle 14px, #ff6700 100%, transparent 0);
      background-size: 48px 15px, 15px 35px, 15px 35px, 25px 15px, 28px 28px;
      background-position: 25px 5px, 58px 20px, 25px 17px, 2px 37px, 76px 0px;
      background-repeat: no-repeat;
      position: relative;
      transform: rotate(-45deg);
      &::after {
        content: "";
        position: absolute;
        width: 56px;
        height: 56px;
        border: 6px solid #ff6700;
        border-radius: 50%;
        left: -45px;
        top: -10px;
        background-repeat: no-repeat;
        background-image: linear-gradient(#ff6700 64px, transparent 0), linear-gradient(#ff6700 66px, transparent 0), radial-gradient(circle 4px, #ff6700 100%, transparent 0);
        background-size: 40px 1px, 1px 40px, 8px 8px;
        background-position: center center;
        -webkit-animation: rotation 0.3s linear infinite;
        animation: rotation 0.3s linear infinite;
      }
      &::before {
        left: 25px;
        top: 60px;
        content: "";
        position: absolute;
        width: 56px;
        height: 56px;
        border: 6px solid #ff6700;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-image: linear-gradient(#ff6700 64px, transparent 0), linear-gradient(#ff6700 66px, transparent 0), radial-gradient(circle 4px, #ff6700 100%, transparent 0);
        background-size: 40px 1px, 1px 40px, 8px 8px;
        background-position: center center;
        -webkit-animation: rotation 0.3s linear infinite;
        animation: rotation 0.3s linear infinite;
      }
    }
    h3 {
      padding-top: 60px;
      color: #ff6700;
      font-size:16px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/myloading.vue